import { Link } from "react-router-dom";

export const Logo = ({ light = false, to = "/", testId = "brand-logo" }) => (
  <Link to={to} data-testid={testId} className="inline-flex items-center gap-2.5 group">
    <span className="relative grid h-9 w-9 place-items-center rounded-md bg-gold text-navy font-display font-extrabold text-sm tracking-tight transition-transform duration-300 group-hover:-rotate-3">
      EVR
    </span>
    <span className={`font-display font-semibold leading-tight text-[15px] ${light ? "text-white" : "text-navy"}`}>
      EVR Global
      <span className={`block text-[11px] font-medium tracking-[0.16em] uppercase ${light ? "text-white/60" : "text-slate-500"}`}>Solutions</span>
    </span>
  </Link>
);

export const FullPageLoader = () => (
  <div data-testid="page-loader" className="grid min-h-screen place-items-center bg-paper">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-navy/20 border-t-gold" />
  </div>
);
